module.exports = __webpack_public_path__ + "static/media/63.b2889003.png";